import {
  FULFILLMENT_STATE_WAITING_FOR_SHIPPING,
  FULFILLMENT_STATE_NEW,
  FULFILLMENT_STATE_SENT_TO_SUPPLIER,
} from '../constants/orderStates';
import { FULFILLMENT_INTEGRATION_TYPES_ALLOW_SHIP } from '../constants/fulfillments';

export function canFulfill(fulfillment) {
  const {
    currentState: { state },
    warehouse: { orders_integration_type },
  } = fulfillment;

  return (
    [FULFILLMENT_STATE_WAITING_FOR_SHIPPING, FULFILLMENT_STATE_SENT_TO_SUPPLIER].includes(state) ||
    (state === FULFILLMENT_STATE_NEW && FULFILLMENT_INTEGRATION_TYPES_ALLOW_SHIP.includes(orders_integration_type))
  );
}
export const areAllItemsReturned = (row) => {
  let returnedQuantity = 0;
  let shippedQuantity = 0;

  const doesLineQuantityExist = (line) => !!line.quantity;

  const fulfillmentWithReturns = row.fulfillments?.filter(
    (fulfillment) => fulfillment.fulfillment_returns && fulfillment.fulfillment_shipments,
  );

  fulfillmentWithReturns?.forEach(async (fulfillment) => {
    fulfillment.fulfillment_returns.forEach((fulfillment_return) => {
      returnedQuantity += fulfillment_return.fulfillment_return_lines?.reduce(
        (accumulator, return_line) =>
          doesLineQuantityExist(return_line) ? accumulator + return_line.quantity : accumulator,
        0,
      );
    });

    fulfillment.fulfillment_shipments.forEach((fulfillment_shipment) => {
      shippedQuantity += fulfillment_shipment.fulfillment_shipment_lines?.reduce(
        (accumulator, shipment_line) =>
          doesLineQuantityExist(shipment_line) ? accumulator + shipment_line.quantity : accumulator,
        0,
      );
    });
  });
  return shippedQuantity - returnedQuantity <= 0;
};
